'use strict';

var React = require('react');

var SvgUnderlineMajor = function SvgUnderlineMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.75a.75.75 0 0 0-1.5 0v6a4.25 4.25 0 0 0 8.5 0v-6a.75.75 0 0 0-1.5 0v6a2.75 2.75 0 1 1-5.5 0v-6Zm-2.5 11.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5h-10.5Z"
  }));
};
SvgUnderlineMajor.displayName = "UnderlineMajor";

exports.SvgUnderlineMajor = SvgUnderlineMajor;
